import GModal from "./g-modal";
import { CarouselManager } from "../utils/carouselManager";

class HeaderMenuNav extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const initSliderFn = () => {
      if (window.innerWidth < 1024) return;
      this._initSlider();
      window.removeEventListener("resize", initSliderFn);
    };

    window.addEventListener("resize", initSliderFn);
    initSliderFn();
  }

  _initSlider() {
    CarouselManager.create(this.querySelector(".splide"), {
      arrows: false,
      pagination: false,
      autoHeight: true,
      autoWidth: true,
      gap: 8,
      breakpoints: {
        640: {
          destroy: true,
        },
      },
    });
  }

  get sectionId() {
    return this.dataset.sectionId;
  }
}

class HeaderMenuModal extends GModal {
  constructor() {
    super();

    this.contents = this.querySelectorAll(".js-modal-content");
    this.headerMenus = this.querySelectorAll(".js-header-menus-dsk");
    this.openedMenus = [null, null, null, null];
    this.selectedBtns = [null, null, null, null];
  }

  _openMenu(key, level) {
    const menu = this.querySelector(`.js-header-menu-dsk[data-menu="${key}"]`);
    const button = document.querySelector(`.js-open-menu[data-menu-key="${key}"]`);
    if(menu && button) {
      if(this.openedMenus[level]?.dataset.menu === key) return;
      for (let i = this.openedMenus.length - 1; i >= level; i--) {
        this._closeMenu(i);
        if(i !== level) {
          this.headerMenus[i].setAttribute('aria-expanded', false);
        }
      }

      this.headerMenus[level].setAttribute('aria-expanded', true);
      this.openedMenus[level] = menu;
      this.selectedBtns[level] = button;
      menu.setAttribute("aria-hidden", false);
      button.setAttribute("aria-selected", true);
    } else {
      console.warn('Menu or button not found');
    }
  }

  _closeMenu(level) {
    this.openedMenus[level]?.setAttribute("aria-hidden", true);
    this.selectedBtns[level]?.setAttribute("aria-selected", false);
    this.openedMenus[level] = null;
    this.selectedBtns[level] = null;
  }

  connectedCallback() {
    const menuLevels = document.querySelectorAll(".js-menu-level-dsk");
    menuLevels.forEach((levelEl, level) => {
      const event = level === 0 ? "click" : "mouseover";
      const openBtns = levelEl.querySelectorAll(".js-open-menu");
      openBtns.forEach(
        (button) => button.addEventListener(event,
        (e) => {
          e.stopPropagation();
          if(level === 0) {
            this.open();
          }
          this._openMenu(button.dataset.menuKey, level)
        }
      ));

    });

    window.addEventListener("click", (e) => {
      const modalContent = e.target.closest(".js-modal-content");
      let close = true;
      if (modalContent) {
        this.contents.forEach((content) => {
          if (modalContent.isEqualNode(content)) close = false;
        });
      }
      if (close) {
        this.close();
      }
    });

    const closeBtn = this.querySelector(".js-close");
    this.addCloseTrigger("click", closeBtn);
  }

  close() {
    const result = super.close();
    this.headerMenus.forEach((menu) => menu.setAttribute("aria-expanded", false));
    this.openedMenus.forEach((menu, level) => this._closeMenu(level));
    return result;
  }
}

class HeaderMenuModalMob extends GModal {
  constructor() {
    super();

    this.openedMenus = [null, null, null, null, null];
    this.headerMenus = document.querySelectorAll(".js-header-menus-mob");
    this.toggleBtn = document.querySelector(".js-header-menu-mob-toggle");
  }

  connectedCallback() {
    this.headerMenus.forEach((menus, level) => {
      const openBtns = menus.querySelectorAll(".js-open-menu");
      const closeBtns = menus.querySelectorAll(".js-close");
      openBtns.forEach(btn => btn.addEventListener("click", (e) => {
        e.stopPropagation();
        this._openMenu(btn.dataset.menuKey, level + 1);
      }));
      closeBtns.forEach(btn => btn.addEventListener("click", (e) => {
        e.stopPropagation();
        this.headerMenus[level].close();
        this._closeMenu(level);
      }));
    });

    const header = document.querySelector(".js-header");

    header.addEventListener("click", (e) => {
      if (!e.target.isEqualNode(this.toggleBtn)) this.close();
    });

    const headerModalTriggers = header.querySelectorAll(".js-header-modal-trigger");
    const announcementBar = document.querySelector(".js-announcement-bar");
    let offsetTop = header.offsetHeight + 16;
    if (announcementBar) offsetTop += announcementBar.offsetHeight;
    this.closest(".js-header-menu-modal-mob").style.setProperty("--offset-top", offsetTop + "px");

    headerModalTriggers.forEach((modalTrigger) => this.addCloseTrigger("click", modalTrigger));
    this.addToggleTrigger("click", this.toggleBtn);
  }

  _openMenu(key, level) {
    const menu = document.querySelector(`.js-header-menu-mob[data-menu="${key}"]`);
    if(menu) {
      if(this.openedMenus[level]?.dataset.menu === key) return;
      for (let i = this.openedMenus.length - 1; i >= level; i--) {
        this._closeMenu(i);
        if(i !== level) {
          this.headerMenus[i].close();
        }
      }

      this.headerMenus[level].open();
      this.openedMenus[level] = menu;
      menu.setAttribute("aria-hidden", false);
    } else {
      console.warn('Menu not found');
    }
  }

  _closeMenu(level) {
    this.openedMenus[level]?.setAttribute("aria-hidden", true);
    this.openedMenus[level] = null;
  }

  open() {
    super.open();
    this.toggleBtn.setAttribute("aria-expanded", true);
  }

  close() {
    for(let i = this.headerMenus.length - 1; i >= 0; i--) {
      if(i === 0) {
        super.close();
      } else {
        this.headerMenus[i].close();
      }
    };
    this.toggleBtn.setAttribute("aria-expanded", false);
  }

  toggle() {
    const result = super.toggle();

    if (!result) {
      for(let i = this.headerMenus.length - 1; i >= 1; i--) {
        this.headerMenus[i].close();
      };
    }

    return result;
  }
}

if (!customElements.get("header-menu-nav")) {
  customElements.define("header-menu-nav", HeaderMenuNav);
}
if (!customElements.get("header-menu-modal")) {
  customElements.define("header-menu-modal", HeaderMenuModal);
}
if (!customElements.get("header-menu-modal-mob")) {
  customElements.define("header-menu-modal-mob", HeaderMenuModalMob);
}
